import {RECEIVE_AIRPORT_DATA} from "../actions/airportDataActions";

const initialState = {
  items: []
};

export default function (state = initialState, action) {

  switch (action.type) {
    case RECEIVE_AIRPORT_DATA:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/airportReducer.js